import React from "react"
import { useSelector, useDispatch } from "react-redux"
import CruiseLineOnly from "@/auth_descriptor/CruiseLineOnly"
import OperatorOnly from "@/auth_descriptor/OperatorOnly"
import { Button } from "react-bootstrap"
import { isBlank } from "@/utils"
import { getCallDaysByDate } from "../selectors"
import { updateDepartures } from "../Slice"
import { RenderCruiseDeparturesColumn, hasSalesMismatch } from "./Helpers"

const SalesDepartures = ({ date }: { date: string }) => {
  const call = useSelector((state) => getCallDaysByDate(state).get(date))
  const dispatch = useDispatch()

  if (!call) {
    return null
  }

  const { unmatchedSalesDepartures } = call.inventory.currentAllocatingTour

  const onApproveSalesDepartures = async () => {
    await dispatch(updateDepartures({ departures: unmatchedSalesDepartures }))
  }

  return (
    <>
      <OperatorOnly>
        {!isBlank(unmatchedSalesDepartures) && hasSalesMismatch(call) && (
          <tr>
            <td />
            <td />
            <td />
            <td />
            <td>
              {!isBlank(unmatchedSalesDepartures) && (
                <RenderCruiseDeparturesColumn
                  departures={unmatchedSalesDepartures}
                  property="departureTime"
                />
              )}
            </td>
            <td>
              {!isBlank(unmatchedSalesDepartures) && (
                <RenderCruiseDeparturesColumn
                  departures={unmatchedSalesDepartures}
                  property="durationInMinutes"
                />
              )}
            </td>
            <td>
              {!isBlank(unmatchedSalesDepartures) && (
                <RenderCruiseDeparturesColumn
                  departures={unmatchedSalesDepartures}
                  property="minimumCapacity"
                />
              )}
            </td>
            <td>
              {!isBlank(unmatchedSalesDepartures) && (
                <RenderCruiseDeparturesColumn
                  departures={unmatchedSalesDepartures}
                  property="maximumCapacity"
                />
              )}
            </td>
            <td />
            <td>Unmatched sales import</td>
            <td>
              <Button className="primary" onClick={() => onApproveSalesDepartures()}>
                Accept
              </Button>
            </td>
            <td />
            <td />
          </tr>
        )}
      </OperatorOnly>
      <CruiseLineOnly>
        {!isBlank(unmatchedSalesDepartures) && (
          <tr>
            <td />
            <td />
            <td />
            <td />
            <td>
              {!isBlank(unmatchedSalesDepartures) && (
                <RenderCruiseDeparturesColumn
                  departures={unmatchedSalesDepartures}
                  property="departureTime"
                />
              )}
            </td>
            <td>
              {!isBlank(unmatchedSalesDepartures) && (
                <RenderCruiseDeparturesColumn
                  departures={unmatchedSalesDepartures}
                  property="durationInMinutes"
                />
              )}
            </td>
            <td>
              {!isBlank(unmatchedSalesDepartures) && (
                <RenderCruiseDeparturesColumn
                  departures={unmatchedSalesDepartures}
                  property="minimumCapacity"
                />
              )}
            </td>
            <td>
              {!isBlank(unmatchedSalesDepartures) && (
                <RenderCruiseDeparturesColumn
                  departures={unmatchedSalesDepartures}
                  property="maximumCapacity"
                />
              )}
            </td>
            <td />
            <td>Pending sales import</td>
            <td />
            <td />
            <td />
          </tr>
        )}
      </CruiseLineOnly>
    </>
  )
}

export default SalesDepartures
